export default function SecondDeleteModal({ handleDeleteUser, handleCloseDeleteModal }) {
  return (
    <div className='fixed shadow-knowtex-shadow rounded-md w-[70%] h-[40%] top-[30%] right-[15%] z-10 bg-white flex flex-col gap-4 p-8 justify-center items-center'>
      <button className='absolute right-[20px] top-[10px] hover:text-ktx-navy font-bold text-[26px] z-[100]' onClick={handleCloseDeleteModal}>×</button>
      <h2 className="text-[28px] font-bold text-ktx-navy text-center">This will delete the user and all patients associated with this user, are you sure?</h2>
      <button onClick={() => handleDeleteUser()} className="bg-ktx-red hover:bg-red-700 text-white font-bold px-4 py-2 rounded-md w-[30%] mx-auto">Yes, Delete</button>
    </div>
  )
}